import { useTheme, zIndex } from "@repo/tokens";

export const resolveWebSize = (
  value: number | string | undefined,
  fallback: string,
): string => {
  if (typeof value === "number") {
    return `${value}px`;
  }

  if (typeof value === "string") {
    if (value.trim().endsWith("%")) return value;
    if (!isNaN(Number(value))) return `${value}px`;
    return value;
  }

  return fallback;
};

export const useStyles = (
  overLayColor?: string,
  width?: number | string,
  height?: number | string,
  modalPosition?: "relative" | "absolute" | "fixed",
  modalTop?: number,
  modalLeft?: number,
  justifyContent?: "flex-start" | "flex-end" | "center",
  alignItems?: "flex-start" | "flex-end" | "center",
) => {
  const { theme } = useTheme();
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  const isAutoHeight = height === "auto";

  const styles: Record<string, React.CSSProperties> = {
    overlay: {
      position: "fixed",
      inset: 0,
      background: overLayColor ? overLayColor : theme.surface.overlay,
      zIndex: zIndex.modal,
      justifyContent: justifyContent
        ? justifyContent
        : isMobile
          ? "flex-end"
          : "center",
      alignItems: alignItems ? alignItems : isMobile ? "flex-start" : "center",
    },

    modal: {
      position: modalPosition ? modalPosition : "static",
      top: modalPosition === "absolute" ? modalTop : 0,
      left: modalPosition === "absolute" ? modalLeft : undefined,
      width: resolveWebSize(width, "50%"),
      maxWidth: isMobile ? "100%" : undefined,
      ...(isAutoHeight
        ? {
            height: "auto",
            maxHeight: isMobile ? "100dvh" : undefined,
          }
        : {
            maxHeight: isMobile ? "100%" : resolveWebSize(height, "50%"),
          }),
      backgroundColor: theme.surface.card,
      borderTopLeftRadius: `${theme.radii.lg}px`,
      borderTopRightRadius: `${theme.radii.lg}px`,
      borderBottomLeftRadius: isMobile ? 0 : `${theme.radii.lg}px`,
      borderBottomRightRadius: isMobile ? 0 : `${theme.radii.lg}px`,
      overflow: "hidden",
    },

    body: isAutoHeight
      ? {
          flexGrow: 0,
          flexShrink: 0,
          overflow: "visible",
        }
      : {
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
        },
  };
  return styles;
};
